<p-toast [baseZIndex]="1000" position="top-right"></p-toast>
<p-confirmDialog [style]="{width: '50vw'}"></p-confirmDialog>
<div class="container-fluid">
  <form [formGroup]="entidadeForm" autocomplete="off">
    <div class="card-panel mt-5">
      <div class="row">
        <div class="col-md-6">
          <lib-page-header page-title="META DE GOVERNO"
            page-subtitle="EXERCÍCIO: {{login.exercicio.ano}} - {{login['ppa']['descricao']}}" show-change="true"
            image-title="assets/img/seo-report.png">
          </lib-page-header>
        </div>
        <div class="col-md-6">
          <a (click)="voltar()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="cvs" title="Sair" height="20" width="20">
          </a>
          <a [routerLink]="['/metas-governo']" class="btn btn-sm btn-outline-secondary float-right">
            <img src="assets/img/global/table_sort_filter.png" alt="pesquisa" title="Pesquisar" height="22" width="22">
          </a>
          <button (click)="submitForm()" type="submit" class="btn btn-outline-info float-right mr-4"
            style="font-size: 13px">Salvar meta</button>
        </div>
      </div>
      <hr class="mt-0 mb-4" />
      <ul class="nav nav-tabs" role="tablist">
        <li class="nav-item">
          <a class="nav-link active" href="#tab1" role="tab" data-toggle="tab">Dados do programa</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#tab2" role="tab" data-toggle="tab">Avaliações periódicas</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#tab3" role="tab" data-toggle="tab">Avaliações dos indicadores</a>
        </li>
      </ul>

      <!-- Tab panes -->
      <div class="tab-content">
        <div role="tabpanel" class="tab-pane active" id="tab1">
          <br />
          <div class="row">
            <div class="col-md-6">
              <div class="form-row mb-1">
                <div class="form-group col-md-4">
                  <label for="tipo">Tipo<span class="text-danger">*</span></label>
                  <select #tipo_ [compareWith]="compareFn" formControlName="tipo" id="tipo" class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f.tipo.errors }">
                    <option *ngFor="let item of listaTipos" [value]="item.id">{{item.nome}}</option>
                  </select>
                </div>
                <div class="form-group col-md-8">
                  <label for="especie">Classificação<span class="text-danger">*</span></label>
                  <select [compareWith]="compareFn" formControlName="especie" id="especie" class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f.especie.errors }">
                    <option *ngFor="let item of listaClassificacao" [value]="item.id">{{item.nome}}</option>
                  </select>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="programa">Programa de governo<span class="text-danger">*</span></label>
                  <p-autoComplete formControlName="programa" [field]="programaAutoComplete.conversor"
                    [suggestions]="programaAutoComplete.lista" (completeMethod)="programaAutoComplete.filtrar($event)"
                    placeholder="Informe o nome do programa" inputStyleClass="form-control font-weight-bold"
                    [style]="{ width: '100%' }" [autoHighlight]="true" (onBlur)="existePrograma()"
                    [ngClass]="{ 'is-invalid': submitted && f.programa.errors }" *ngIf="programaAutoComplete">
                    <ng-template let-programa pTemplate="item">
                      {{programa.codigo}} {{programa.nome}}
                    </ng-template>
                  </p-autoComplete>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="unidade">Unidade administrativa<span class="text-danger">*</span></label>
                  <p-autoComplete formControlName="unidade" [field]="unidadeAutoComplete.conversor"
                    [suggestions]="unidadeAutoComplete.lista" [dropdown]="true"
                    (completeMethod)="unidadeAutoComplete.filtrar($event)"
                    [ngClass]="{ 'is-invalid': submitted && f.unidade.errors }"
                    placeholder="Informe o unidade administrativa" inputStyleClass="form-control font-weight-bold"
                    minLength="2" [style]="{ width: '100%' }" [forceSelection]="true" [autoHighlight]="true"
                    *ngIf="unidadeAutoComplete">
                    <ng-template let-unidade pTemplate="item">
                      {{unidade.codigo}} {{unidade.nome}}
                    </ng-template>
                  </p-autoComplete>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="checkbox checbox-switch switch-danger">
                    <label>
                      <input formControlName="continuado" type="checkbox" />
                      <span></span>
                      Programa continuado
                    </label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="checkbox checbox-switch switch-danger">
                    <label>
                      <input formControlName="aprovado" type="checkbox" />
                      <span></span>
                      Aprovado
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="alvo">Público alvo<span class="text-danger">*</span></label>
                  <input formControlName="alvo" type="text" class="form-control" id="alvo"
                    [ngClass]="{ 'is-invalid': submitted && f.alvo.errors }">
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="funcao">Função Governo<span class="text-danger">*</span></label>
                  <p-autoComplete formControlName="funcao" [field]="funcaoAutoComplete.conversor"
                    [suggestions]="funcaoAutoComplete.lista" (completeMethod)="funcaoAutoComplete.filtrar($event)"
                    placeholder="Informe a função" inputStyleClass="form-control" minLength="2" [dropdown]="true"
                    [style]="{ width: '100%' }" [forceSelection]="true" [autoHighlight]="true"
                    *ngIf="funcaoAutoComplete" [ngClass]="{ 'is-invalid': submitted && f.funcao.errors }">
                    <ng-template let-funcao pTemplate="item">
                      {{funcao.codigo}} {{funcao.nome}}
                    </ng-template>
                  </p-autoComplete>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="programa">Subfunção<span class="text-danger">*</span></label>
                  <p-autoComplete formControlName="subfuncao" [field]="subFuncaoAutoComplete.conversor"
                    [suggestions]="subFuncaoAutoComplete.lista" (completeMethod)="subFuncaoAutoComplete.filtrar($event)"
                    placeholder="Informe o código e nome da subfunção" inputStyleClass="form-control" minLength="2"
                    [style]="{ width: '100%' }" [forceSelection]="true" [autoHighlight]="true" [dropdown]="true"
                    [ngClass]="{ 'is-invalid': submitted && f.subfuncao.errors }" *ngIf="subFuncaoAutoComplete">
                    <ng-template let-subFuncao pTemplate="item">
                      {{subFuncao.codigo}} {{subFuncao.nome}}
                    </ng-template>
                  </p-autoComplete>
                </div>
              </div>
              <div class="row mb-4">
                <div class="col-md-6">
                  <div class="checkbox checbox-switch switch-primary">
                    <label>
                      <input formControlName="priorizado1" type="checkbox" />
                      <span></span>
                      Priorizado em {{login.ppa.ppaperiodo.ano1}}
                    </label>
                  </div>
                  <div class="checkbox checbox-switch switch-primary">
                    <label>
                      <input formControlName="priorizado2" type="checkbox" />
                      <span></span>
                      Priorizado em {{login.ppa.ppaperiodo.ano2}}
                    </label>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="checkbox checbox-switch switch-primary">
                    <label>
                      <input formControlName="priorizado3" type="checkbox" />
                      <span></span>
                      Priorizado em {{login.ppa.ppaperiodo.ano3}}
                    </label>
                  </div>
                  <div class="checkbox checbox-switch switch-primary">
                    <label>
                      <input formControlName="priorizado4" type="checkbox" />
                      <span></span>
                      Priorizado em {{login.ppa.ppaperiodo.ano4}}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-12">
              <label for="gerente">Gerente do programa<span class="text-danger">*</span></label>
              <input formControlName="gerente" type="text" class="form-control" id="gerente"
                [ngClass]="{ 'is-invalid': submitted && f.gerente.errors }">
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-12">
              <label for="objetivo">Objetivo<span class="text-danger">*</span></label>
              <textarea formControlName="objetivo" class="form-control" id="objetivo" rows="4"
                [ngClass]="{ 'is-invalid': submitted && f.objetivo.errors }"></textarea>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-12">
              <label for="justificativa">Justificativa<span class="text-danger">*</span></label>
              <textarea formControlName="justificativa" class="form-control" id="justificativa" rows="5"
                [ngClass]="{ 'is-invalid': submitted && f.justificativa.errors }"></textarea>
            </div>
          </div>
          <div class="row">
            <div class="col-md">
              <app-indicador-form [(lista)]="listaIndicadores" [(entidade)]="entidade" [login]="login">
              </app-indicador-form>
            </div>
          </div>
        </div>
        <div role="tabpanel" class="tab-pane fade" id="tab2">
          <br>
          <app-meta-avaliacao-form [(entidade)]="entidade" [(lista)]="listaAvaliacoes" [login]="login">
          </app-meta-avaliacao-form>
        </div>
        <div role="tabpanel" class="tab-pane fade" id="tab3">
          <br>
          <app-indicador-avaliacao-form [(entidade)]="entidade" [(lista)]="listaIndicadores" [login]="login">
          </app-indicador-avaliacao-form>
        </div>
      </div>
    </div>
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
    <div id="footer" class="row mt-4">
      <div class="offset-1 col-11 ml-5 pl-3 pt-3 mb-3">
        <button (click)="submitForm(true)" class="btn btn-sm btn-secondary">
          <img src="assets/img/global/tick.png" alt="salvar" height="20" width="20">
          Salvar e novo
        </button>
      </div>
    </div>
  </form>
</div>

<app-programa-dlg [login]="login" (atualizarPrograma)="updatePrograma()"></app-programa-dlg>
